import { render } from "./component.vue?vue&type=template&id=95028740"
import script from "./component.vue?vue&type=script&setup=true&lang=js"
export * from "./component.vue?vue&type=script&setup=true&lang=js"

import "./component.vue?vue&type=style&index=0&id=95028740&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/plugins/modals/component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95028740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95028740', __exports__)) {
    api.reload('95028740', __exports__)
  }
  
  module.hot.accept("./component.vue?vue&type=template&id=95028740", () => {
    api.rerender('95028740', render)
  })

}


export default __exports__